// src/pages/IndoorMap/routeInstructions.js
export const ROUTE_INSTRUCTIONS = {
  "valet__main-hall": [
    "Enter the venue through the main entrance.",
    "Walk straight ahead towards the Convention Hall.",
    "Enter the Convention Hall through the main entrance.",
  ],
  "main-hall__valet": [
    "Exit the Convention Hall through the main entrance.",
    "Walk straight towards the venue exit.",
    "Continue outside to reach the Convention Hall Entrance.",
  ],
  "valet__food-radio": [
    "Enter the venue and walk towards the Convention Hall.",
    "Continue through the Convention Hall towards the right-side exit.",
    "Follow the corridor towards the Courtyard.",
    "Exit into the Courtyard to reach it.",
  ],
  "food-radio__valet": [
    "Exit the Courtyard towards the corridor leading to the Convention Hall.",
    "Walk through the Convention Hall towards the main entrance.",
    "Exit the venue through the main entrance.",
    "Continue to the Convention Hall Entrance.",
  ],
  "main-hall__food-radio": [
    "Exit the Convention Hall from the right-side entrance.",
    "Follow the corridor towards the Courtyard.",
    "Continue straight until you reach the Courtyard.",
    "Enter the Courtyard.",
  ],
  "food-radio__main-hall": [
    "Exit the Courtyard towards the corridor.",
    "Follow the corridor towards the Convention Hall.",
    "Continue straight and enter the Convention Hall.",
  ],
  "main-hall__experience-zone": [
    "Exit the Convention Hall towards the right-side corridor.",
    "Continue through the pre-function area.",
    "Follow the corridor towards the Scarlet Ballroom.",
    "Enter the Scarlet Ballroom.",
  ],
  "experience-zone__main-hall": [
    "Exit the Scarlet Ballroom into the pre-function area.",
    "Follow the corridor towards the Convention Hall.",
    "Continue straight and enter the Convention Hall.",
  ],
  "valet__experience-zone": [
    "Enter the venue and proceed towards the Convention Hall.",
    "Walk through the Convention Hall towards the right-side corridor.",
    "Continue through the pre-function area.",
    "Follow the corridor towards the Scarlet Ballroom.",
    "Enter the Scarlet Ballroom.",
  ],
  "experience-zone__valet": [
    "Exit the Scarlet Ballroom into the pre-function area.",
    "Follow the corridor towards the Convention Hall.",
    "Walk through the Convention Hall towards the main entrance.",
    "Exit the venue and continue to the Convention Hall Entrance.",
  ],
  "food-radio__experience-zone": [
    "Exit the Courtyard towards the right-side corridor.",
    "Continue through the pre-function area.",
    "Follow the corridor towards the Scarlet Ballroom.",
    "Enter the Scarlet Ballroom.",
  ],
  "experience-zone__food-radio": [
    "Exit the Scarlet Ballroom into the pre-function area.",
    "Follow the corridor towards the Courtyard.",
    "Continue through the corridor and enter the Courtyard.",
    "You have reached the Courtyard.",
  ],
}

// Directional — order matters, unlike resolveRoute's sorted key.
export function getInstructions(startId, endId) {
  if (!startId || !endId || startId === endId) return null
  return ROUTE_INSTRUCTIONS[`${startId}__${endId}`] || null
}